import React, { useState } from "react";
import {
  Card,
  Layout,
  TextStyle,
  TextContainer,
  Button,
  Link,
  ButtonGroup,
} from "@shopify/polaris";
import LicensePrompt from "../LicensePrompt";
import { getStripePortalUrl } from "services/wpApi";

export default function Billing({ shop }) {
  const [loadingPortal, setLoadingPortal] = useState(false);
  const hasComplimentaryAccess = shop.monthlyFeeWaived;

  const handleManageSubscription = async () => {
    setLoadingPortal(true);
    try {
      const { data } = await getStripePortalUrl();
      if (data.url) {
        window.location.href = data.url;
      } else if (data.error) {
        console.error("Portal error:", data.error);
        setLoadingPortal(false);
      }
    } catch (err) {
      console.error("Failed to open billing portal:", err);
      setLoadingPortal(false);
    }
  };

  return (
    <Layout.AnnotatedSection
      title="Billing"
      description={
        <>
          <p>Update your Real ID monthly plan at any time.</p>
          <br />
        </>
      }
    >
      {!shop.usageSubscriptionItems || shop.sandboxMode ? (
        <LicensePrompt />
      ) : (
        <Card fullWidth title="Current Plan">
          <Card.Section>
            {shop.usageSubscriptionItems && shop.monthlyPlan && shop.usagePlan && (
              <TextContainer spacing="loose">
                <strong style={{ textTransform: "uppercase" }}>
                  {shop.monthlyPlan}
                </strong>
                <p>
                  With {shop.usagePlan == "ai" && "A.I. powered"}
                  {shop.usagePlan == "lite" && "Manual powered"} ID checking
                </p>
                {shop.pricePerCheck && (
                  <p>
                    <span
                      style={{
                        textDecoration: hasComplimentaryAccess
                          ? "line-through"
                          : "none",
                      }}
                    >
                      ${shop.pricePerCheck} per ID check.
                    </span>
                    {hasComplimentaryAccess && (
                      <>
                        &nbsp;Special complimentary pricing -{" "}
                        <TextStyle variation="positive">
                          ${shop.complimentaryPricePerCheck}
                        </TextStyle>{" "}
                        per I.D. check
                      </>
                    )}
                  </p>
                )}
                <ButtonGroup>
                  <Button
                    onClick={handleManageSubscription}
                    loading={loadingPortal}
                  >
                    Manage Subscription
                  </Button>
                  <Button url="https://dashboard.getverdict.com">
                    Change Plan
                  </Button>
                </ButtonGroup>
              </TextContainer>
            )}
          </Card.Section>
        </Card>
      )}
    </Layout.AnnotatedSection>
  );
}
